import React, { useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { blockWorkstations } from "../../store/actions";



const BlockWorkstation= function(props){
    let ws=props.ws
    const [showAlert,setShowAlert] = useState(false)
    let user=JSON.parse(localStorage.getItem("authUser"))

    const blcokWorkstations=()=>{
    
        props.blockWorkstations(ws,user.token,props.history)
    }
    const noBlockTasks=()=>{
        setShowAlert(false)
    }
    const pressButton=(event)=>{
        event.preventDefault()
        setShowAlert(true)
    }
  
    return(
        <React.Fragment>
            <Button className="btn btn-danger waves-effect waves-light buttonStatus wsButton" onClick={(event)=>pressButton(event)}>  <i className="bx bx-lock font-size-16 align-middle mr-2"/></Button>
            {showAlert &&(
                <SweetAlert
                title= { props.t("¿Está seguro? ")}
             
                warning
              
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                cancelBtnText={props.t("cancel")}
                confirmBtnText={props.t("ok")}
                onConfirm={() => blcokWorkstations()}
                onCancel={()=>noBlockTasks()}
              >
                 {props.t("Vas a bloquear la estacion de trabajo, ")}
                 <br/>
                 {props.t("esta se bloqueara cuando se finalizen sus tareas")}
              </SweetAlert>
            
          ) }

        </React.Fragment>
    )
}


const mapStateProps = (state) => {
   
    const {  loadingBlockWs} = state.BlockWorkstation;
    
    return { loadingBlockWs};
  };
  
export default withRouter(
    connect(mapStateProps, {
        blockWorkstations
    })(withNamespaces()(BlockWorkstation))
  );